import { render, staticRenderFns } from "./UpdateGrade.vue?vue&type=template&id=7b4e3a40&scoped=true"
import script from "./UpdateGrade.vue?vue&type=script&lang=js"
export * from "./UpdateGrade.vue?vue&type=script&lang=js"
import style0 from "./UpdateGrade.vue?vue&type=style&index=0&id=7b4e3a40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4e3a40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b4e3a40')) {
      api.createRecord('7b4e3a40', component.options)
    } else {
      api.reload('7b4e3a40', component.options)
    }
    module.hot.accept("./UpdateGrade.vue?vue&type=template&id=7b4e3a40&scoped=true", function () {
      api.rerender('7b4e3a40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/GradeDialog/UpdateGrade.vue"
export default component.exports